import React from 'react';
import DateRangePicker from '../../../../../../components/datePicker/DateRangePicker';
import Select from '../../../../../../components/input/Select/Select';
import {
  DATE_FORMAT,
  DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT,
} from '../../../../../../constants/service/common/utilConstants';
import {
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_TEXT,
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_SELECT_LIST,
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE,
} from '../../../../../../constants/service/app/accountUserConstants';
import { addAllItemToSelectList, setColumnWidth } from '../../../../../../lib/common';
import { setDateFormat } from '../../../../../../lib/moment';
import Img from '../../../../../../components/Img/Img';
import OpenProductDetail from '../../../../../../components/link/OpenProductDetail';
import TableFilterInput from '../../../../../../components/table/TableFilterInput';
import OpenPreviewProductDetail from '../../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenBrandDetail from '../../../../../../components/link/OpenBrandDetail';
import TableColumnImg from '../../../../../../components/table/TableColumnImg';

/**
 *  유저 장바구니 타임라인 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter, mainProductCategorySelectList } = data;

  return [
    {
      accessor: 'no',
      Header: '순번',
      width: 80,
      Cell: (row) => row.value,
    },
    {
      accessor: 'url',
      Header: '메인 이미지',
      width: 120,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      filterable: true,
      width: 100,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      filterable: true,
      width: setColumnWidth(list, 'productName'),
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      filterable: true,
      Filter: () => (
        <Select
          list={addAllItemToSelectList(mainProductCategorySelectList)}
          onChange={(mainCategory) =>
            onFilter({
              mainCategory,
              subCategory: null,
            })
          }
          defaultValue={filterOption.mainCategory}
          value={filterOption.mainCategory}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'storeName',
      Header: '브랜드명',
      filterable: true,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      width: 100,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'actionLogType',
      Header: '활동 내역',
      filterable: true,
      width: 140,
      Cell: (row) =>
        row.value === ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.CLICK
          ? ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_TEXT[row.value]
          : `상품 ${ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_TEXT[row.value]}`,
      Filter: () => (
        <Select
          list={addAllItemToSelectList(ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_SELECT_LIST)}
          onChange={(actionLogType) => onFilter({ actionLogType })}
          value={filterOption.actionLogType}
          isTable
          size="large"
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '활동 시간',
      filterable: true,
      sortable: true,
      width: 180,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          showTime={true}
          btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          startText={DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT}
          endText={DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT}
          outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          format={DATE_FORMAT.FULL_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
  ];
};

export default columns;
